<template>
  <b-row>
    <b-col>
      <b-row :class="rowClass">
        <b-col :cols="5" style="white-space: nowrap;">{{ $t('COMPONENT_playlistcard_duration') }}</b-col>
        <b-col :cols="7">
          <LoadingLine v-if="loading && !duration" width="35%" />
          <div v-else style="min-height: 26px">
            {{ Math.ceil(duration / 60) }} {{ $t('minutes') }}
          </div>
        </b-col>
      </b-row>
      <b-row :class="rowClass">
        <b-col :cols="5" style="white-space: nowrap;">{{ $t('COMPONENT_playlistcard_bodyparts') }}</b-col>
        <b-col :cols="7">
          <LoadingLine v-if="loading && !areas" width="50%" />
          <BodyParts v-else :parts="areas" :showInactive="true" />
        </b-col>
      </b-row>
      <b-row :class="rowClass">
        <b-col :cols="5" style="white-space: nowrap;">{{ $t('resources') }}</b-col>
        <b-col :cols="7">
          <LoadingLine v-if="loading && !resources" width="45%" />
          <Resources v-else :resources="resources" :showInactive="true" />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import LoadingLine from '@/elements/LoadingLine';
import BodyParts from '@/elements/BodyParts';
import Resources from '@/elements/Resources';

export default {
  name: 'ProgrammMeta',
  props: {
    areas: {
      default: null,
    },
    resources: {
      default: null,
    },
    duration: { default: null },
    loading: { default: false },
    rowClass: { default: 'mt-3' },
  },

  components: {
    LoadingLine,
    BodyParts,
    Resources,
  },
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/elements/ProgrammMeta.vue